/* eslint-disable react-hooks/exhaustive-deps */
import IconBack from '../../assets/Images/icons/icon-back';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Form, Input, Row, Col, Select } from 'antd';
import { useEffect, useState } from 'react';
import UserManagement from '../../services/UserManagement.service';
import UserService from '../../services/UserService';
import DataInventoryService from '../../services/DataInventory.service';
import ModalSuccess from '../../components/Shared/modal/success';
import ModalFail from '../../components/Shared/modal/fail';
import MyCompanyService from '../../services/MyCompany.service';
const { Option } = Select;

export default function Profile() {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const id = UserService.getUi();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { mode } = useParams();
    const [loading, setLoading] = useState(true);
    const [saveLoading, setSaveLoading] = useState(false);

    const [roleUser, setRoleUser] = useState([]);

    const [disableForm, setDisableForm] = useState(true);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openFail, setOpenFail] = useState(false);

    const [userDetail, setUserDetail] = useState();
    const [companyList, setCompanyList] = useState();

    const getRoleUser = () => {
        UserManagement.getRoleUser().then((res) => {
            setRoleUser(res?.data?.resultData || []);
        });
    };

    const getUserDetail = async () => {
        try {
            const { data } = await UserManagement.getUserDetail(id);
            const item = data?.resultData;

            localStorage.setItem('name', `${item.fname} ${item.lname}`);
            localStorage.setItem('role', `${item.role}`);
            form.setFieldsValue({
                ...item,
                firstName: item?.fname,
                lastName: item?.lname,
                companyName: item?.companyId,
                departmentName:
                    lang === 'en' ? item?.departmentEn : item?.departmentTh,
            });
            setLoading(false);
            getDomainList(item?.companyId, item?.domainId);
            setUserDetail(item);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (loading) {
            getRoleUser();

            getUserDetail();
        }
    }, [loading]);

    useEffect(() => {
        getRoleUser();

        getUserDetail();
        getCompanyList();
    }, [lang]);

    useEffect(() => {
        if (mode === 'edit') {
            setDisableForm(false);
        } else {
            setDisableForm(true);
        }
    }, [mode]);

    const onFinish = async (value) => {
        setSaveLoading(true);
        try {
            const { data } = await UserManagement.editUserDetail({
                ...userDetail,
                phone: value.phone,
                firstName: value.firstName,
                lastName: value.lastName,
            });
            setSaveLoading(false);
            if (data?.resultCode === 0) {
                setOpenFail(true);
            } else {
                setOpenSuccess(true);
                getUserDetail();
                setTimeout(() => {
                    navigate('/profile');
                }, 1500);
            }
        } catch (error) {
            setSaveLoading(false);
            setOpenFail(true);
        }
    };

    const getDomainList = async (companyId, domain) => {
        let ObjectSearch = {};
        ObjectSearch = {
            companyId: companyId,
            p: 1,
            ps: 10000,
            s: 'domainName',
            sd: 'DESC',
        };
        try {
            const { data } = await MyCompanyService.getDomainList(ObjectSearch);
            const item = data?.resultData;
            let list = [];
            item?.result?.forEach((element) => {
                let id = element?.domainId;
                if (domain.includes(id)) {
                    list.push(element);
                }
            });
            form.setFieldsValue({
                companyName: item?.result[0]?.companyName,
            });
        } catch (err) {
            console.log(err);
        }
    };

    const getCompanyList = () => {
        DataInventoryService.getCompanyList().then((res) => {
            setCompanyList(res?.data?.resultData || []);
        });
    };

    return (
        <div>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        navigate(-1);
                    }}
                >
                    <IconBack />
                </div>
                {t('userManagement.Profile')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('userManagement.LandingPage')} /{' '}
                </span>
                <span>{t('userManagement.Profile')}</span>
            </div>
            <div className="w-full m-auto">
                <div
                    className="content bg-white p-8 mt-6"
                    style={{ borderRadius: '6px' }}
                >
                    <div className="content pb-3">
                        <Form
                            scrollToFirstError={{
                                behavior: 'smooth',
                                block: 'center',
                            }}
                            onFinish={onFinish}
                            form={form}
                            className="w-full"
                            layout="vertical"
                        >
                            <Row
                                style={{
                                    borderBottom: '1px solid #F4F6FC',
                                    marginBottom: 20,
                                }}
                            >
                                <Col span={12} style={{ marginBottom: 20 }}>
                                    <div>
                                        <Row>
                                            <div
                                                className="title"
                                                style={{ color: '#7B67FB' }}
                                            >
                                                {t(
                                                    'userManagement.UserInformation'
                                                )}
                                            </div>
                                        </Row>
                                    </div>
                                </Col>
                                <Col span={12} className="w-full">
                                    <Row>
                                        <Col span={24} className="w-full">
                                            <Row
                                                style={{
                                                    position: 'absolute',
                                                    right: 0,
                                                }}
                                            >
                                                {disableForm ? (
                                                    <Button
                                                        onClick={() => {
                                                            navigate(
                                                                `/profile/${'edit'}`
                                                            );
                                                        }}
                                                        size="large"
                                                        className="w-[120px] text-[#7B67FB] border-[#7B67FB]"
                                                    >
                                                        {t('Edit')}
                                                    </Button>
                                                ) : (
                                                    <>
                                                        <div className="space-x-3">
                                                            <Button
                                                                size="large"
                                                                htmlType="reset"
                                                                type="default"
                                                                className="w-[120px] text-[#7B67FB] border-[#7B67FB]"
                                                                onClick={() => {
                                                                    setDisableForm(
                                                                        true
                                                                    );
                                                                    form.resetFields();
                                                                    navigate(
                                                                        '/profile'
                                                                    );
                                                                    setLoading(
                                                                        true
                                                                    );
                                                                }}
                                                            >
                                                                {t('Cancel')}
                                                            </Button>
                                                            <Button
                                                                loading={
                                                                    saveLoading
                                                                }
                                                                size="large"
                                                                htmlType="submit"
                                                                type="primary"
                                                                className="w-[120px]"
                                                            >
                                                                {t('Save')}
                                                            </Button>
                                                        </div>
                                                    </>
                                                )}
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            <div className="grid grid-cols-3 gap-10">
                                <div className="p-1">
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('First name')}
                                            </span>
                                        }
                                        name="firstName"
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.FirstNameIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            size="large"
                                            placeholder={t('First name')}
                                            showCount
                                            maxLength={20}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('Phone Number')}
                                            </span>
                                        }
                                        name="phone"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.PhoneNumberIsrequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            size="large"
                                            placeholder={t('Phone Number')}
                                            showCount
                                            maxLength={15}
                                            disabled={disableForm}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('Staff ID')}
                                            </span>
                                        }
                                        name="staffId"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.StaffIDIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            size="large"
                                            placeholder={t('Staff ID')}
                                            showCount
                                            maxLength={20}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('Role')}
                                            </span>
                                        }
                                        name="roleId"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.RoleIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Select
                                            size="large"
                                            style={{ textAlign: 'left' }}
                                            placeholder={t('Role')}
                                            disabled={true}
                                        >
                                            {roleUser.map((role) => (
                                                <Option
                                                    size="large"
                                                    key={role.id}
                                                    value={role.id}
                                                    hidden={
                                                        role.id ===
                                                        'ebf0bfbb0fd74b43975472b0820a62a6'
                                                    }
                                                >
                                                    {role.role}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </div>
                                <div className="p-1">
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('Last name')}
                                            </span>
                                        }
                                        name="lastName"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.LastNameIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            size="large"
                                            placeholder={t('Last name')}
                                            showCount
                                            maxLength={20}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('Email')}
                                            </span>
                                        }
                                        name="email"
                                        colon={false}
                                        rules={[
                                            {
                                                type: 'email',
                                                message: t(
                                                    'MyCompany.EmailNotValid'
                                                ),
                                            },
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.EmailIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            size="large"
                                            placeholder={t('Email')}
                                            showCount
                                            maxLength={50}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('Department')}
                                            </span>
                                        }
                                        name="departmentName"
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.DepartmentIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            size="large"
                                            placeholder={t('Department')}
                                            disabled={true}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('Company Name')}
                                            </span>
                                        }
                                        name="companyId"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.CompanyNameIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Select
                                            size="large"
                                            style={{ textAlign: 'left' }}
                                            placeholder={t('Company Name')}
                                            disabled={true}
                                        >
                                            {companyList?.map((e) => (
                                                <Option
                                                    size="large"
                                                    key={e.id}
                                                    value={e.id}
                                                >
                                                    {e.companyName}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </div>
                                {/* <div className="pl-10 pr-10">
                                    <div
                                        className="rounded-md py-4 pl-4 pr-2 mb-4 inline-grid w-full bg-white"
                                        style={{ border: '1px solid #DBDBDB' }}
                                    >
                                        <div className="px-2">
                                            <div className="font-semibold text-[16px] mb-2">
                                                {t(
                                                    'userManagement.ConfigurePermissions'
                                                )}
                                            </div>
                                            <div className="font-base text-[12px] text-[#B7B7C0] mb-2">
                                                ({t('userManagement.Optional')})
                                            </div>
                                            <div className="font-base text-[12px] text-[#65707A] mb-1">
                                                {t(
                                                    'userManagement.SpecifyCustomize'
                                                )}
                                            </div>
                                        </div>

                                        <div className="px-2 overflow-auto h-96 mt-2">
                                            {domainList?.length > 0 ? (
                                                <>
                                                    {domainList?.map((is) => {
                                                        return (
                                                            <div
                                                                className="mb-2"
                                                                key={
                                                                    is.domainId
                                                                }
                                                            >
                                                                &#8226;{' '}
                                                                {is.domainName}
                                                                <br />
                                                            </div>
                                                        );
                                                    })}
                                                </>
                                            ) : (
                                                <div className="h-[40vh] flex justify-center items-center">
                                                    <IconEmptyDomain />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </Form>
                    </div>
                </div>
                <ModalSuccess
                    open={openSuccess}
                    handelClose={() => setOpenSuccess(false)}
                />
                <ModalFail
                    open={openFail}
                    handelClose={() => setOpenFail(false)}
                />
            </div>
        </div>
    );
}
